// Utilitário para obter a URL do backend
export const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;

  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const isCustomDomain = currentHost && !currentHost.includes('preview.emergentagent.com') && !currentHost.includes('localhost');

    if (isCustomDomain) {
      return window.location.origin;
    }
  }

  return envUrl;
};

export const API_URL = getBackendUrl();
